import React from 'react';
import PropTypes from 'prop-types';

import { deleteRequest } from 'helpers/api';

import Dropdown from 'components/dropdown';
import DeductionCategoryModal from './modal';
import { buildCategoryObject } from './helpers';

export class DeductionCategoryRow extends React.Component {
  static propTypes = {
    deductionCategoriesPath: PropTypes.string.isRequired,
    enableHouseDeductions: PropTypes.bool,
    enableTieredDeductions: PropTypes.bool,
    houseCategory: PropTypes.bool,
    name: PropTypes.string.isRequired,
    paymentCategory: PropTypes.bool.isRequired,
    tier: PropTypes.number,
    voucherCategory: PropTypes.bool.isRequired,
    onDeleteCategory: PropTypes.func.isRequired,
    onUpdateCategory: PropTypes.func.isRequired
  }

  state = {
    houseCategory: this.props.houseCategory,
    name: this.props.name,
    paymentCategory: this.props.paymentCategory,
    voucherCategory: this.props.voucherCategory,
    showModal: false,
    tier: this.props.tier
  }

  showCategoryModal = () => {
    this.setState({ showModal: true });
  }

  hideModalOnCancel = () => {
    this.setState({ showModal: false });
  }

  handleSave = (deductionCategory) => {
    this.props.onUpdateCategory(this.props.name, deductionCategory);
    this.setState({ ...deductionCategory, showModal: false });
  }

  handleDelete = (event) => {
    event.stopPropagation();

    deleteRequest(this.props.deductionCategoriesPath, { data: { name: this.state.name } })
      .then(() => {
        this.props.onDeleteCategory(this.props.name);
      });
  }

  render() {
    const deductionTypes = [];
    if (this.state.voucherCategory) {
      deductionTypes.push('Pre-Split');
    }
    if (this.state.paymentCategory) {
      deductionTypes.push('Individual');
    }
    if (this.state.houseCategory) {
      deductionTypes.push('House');
    }
    
    return <>
      <tr>
        <td colSpan={this.props.enableTieredDeductions ? 3 : 6} name="category-name">
          {this.state.name}
        </td>
        <td colSpan="3">
          {deductionTypes.join(', ')}
        </td>
        {this.props.enableTieredDeductions && (
          <td colSpan="3">
            {this.state.voucherCategory ? this.state.tier : '--'}
          </td>
        )}
        <Dropdown.Cell>
          <Dropdown.Item isEdit onClick={this.showCategoryModal} />
          <Dropdown.Item isDelete onClick={this.handleDelete} />
        </Dropdown.Cell>
      </tr>

      <DeductionCategoryModal
        deductionCategoriesPath={this.props.deductionCategoriesPath}
        deductionCategory={buildCategoryObject(this.state)}
        enableHouseDeductions={this.props.enableHouseDeductions}
        enableTieredDeductions={this.props.enableTieredDeductions}
        name={this.state.name}
        show={this.state.showModal}
        onCancel={this.hideModalOnCancel}
        onSave={this.handleSave}
      />
    </>;
  }
}
export default DeductionCategoryRow;
